define([
    "./nlgBasketModule",
    "./nlgBasketDirective",
    "./nlgBasketServiceFactory"
], function () {
});